module.exports = __webpack_public_path__ + "img/guide-ko-4.2db55c7f.png";